/**
 * Maps a slider value to a scale value.
 * Inverse of getSliderFromScale.
 */
type GetScaleFromSliderParams = {
  sliderValue: number;
  minScale: number;
  sliderMax: number;
  maxScale: number;
  scaleAtCenter?: number; // Required for 'centered' mode
  sliderCenter?: number; // Required for 'centered' mode
  mode?: 'centered' | 'left';
};

export const getScaleFromSlider = ({
  sliderValue,
  minScale,
  sliderMax,
  maxScale,
  scaleAtCenter,
  sliderCenter,
  mode = 'centered',
}: GetScaleFromSliderParams) => {
  if (mode === 'left') {
    // Linear mapping from sliderValue to scale
    if (sliderValue <= 0) return minScale;
    if (sliderValue >= sliderMax) return maxScale;
    return Math.round(minScale + (sliderValue / sliderMax) * (maxScale - minScale));
  } else {
    // Centered mapping: sliderCenter maps to scaleAtCenter
    if (typeof scaleAtCenter !== 'number' || typeof sliderCenter !== 'number') {
      throw new Error('scaleAtCenter and sliderCenter are required in centered mode');
    }
    if (sliderValue === sliderCenter) return scaleAtCenter;
    if (sliderValue < sliderCenter) {
      // Map values below center
      const percent = sliderValue / sliderCenter;
      return Math.round(minScale + (scaleAtCenter - minScale) * percent);
    } else {
      // Map values above center
      const percent = (sliderValue - sliderCenter) / (sliderMax - sliderCenter);
      return Math.round(scaleAtCenter + (maxScale - scaleAtCenter) * percent);
    }
  }
};
